import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { VEHICLE_WARNINGS_INITIAL_STATE } from "../constants/vehicleWarnings.constants";

export const getAllVehicleWarnings = createAsyncThunk(
  "vehicleWarnings/getAll",
  async () => {
    const response = await axios.get("/api/Customer/vehicle/warning/list");
    return response.data;
  }
);

export const getVehicleWarningByRegNo = createAsyncThunk(
  "vehicleWarnings/getByRegNo",
  async (vehicleRegNo: string) => {
    const response = await axios.get(
      `/api/Customer/vehicle/warning/${encodeURIComponent(vehicleRegNo)}`
    );
    return response.data;
  }
);

export const vehicleWarningsSlice = createSlice({
  name: "vehicleWarnings",
  initialState: VEHICLE_WARNINGS_INITIAL_STATE,
  reducers: {
    onChangeVehicleWarningsScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    onChangeVehicleWarningsList: (state, action) => {
      state.pageProps = action.payload;
    },
    onSelectVehicleWarning: (state, action) => {
      state.selectedVehicleWarning = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllVehicleWarnings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllVehicleWarnings.fulfilled, (state, action) => {
        state.loading = false;
        // Transform the API response to match our pagination structure
        const result = action.payload?.result || [];
        state.data = {
          list: result,
          totalPages: Math.ceil(result.length / state.pageProps.perPage),
          totalRecords: result.length,
        };
        state.error = null;
      })
      .addCase(getAllVehicleWarnings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(getVehicleWarningByRegNo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVehicleWarningByRegNo.fulfilled, (state, action) => {
        state.loading = false;
        // Update the selected vehicle warning with detailed data
        const result = action.payload?.result || [];
        if (result.length > 0) {
          state.selectedVehicleWarning = result[0];
        }
        state.error = null;
      })
      .addCase(getVehicleWarningByRegNo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      });
  },
});

export const {
  onChangeVehicleWarningsScreen,
  onChangeVehicleWarningsList,
  onSelectVehicleWarning,
} = vehicleWarningsSlice.actions;

export default vehicleWarningsSlice.reducer;
